import _toConsumableArray from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Signal } from "../signal/Signal";
import { Multiply } from "../signal/Multiply";
import { Gain } from "../core/context/Gain";
import { Envelope } from "../component/envelope/Envelope";
import { ToneAudioNode } from "../core/context/ToneAudioNode";
import { Monophonic } from "./Monophonic";
import { OmniOscillator } from "../source/oscillator/OmniOscillator";
import { Source } from "../source/Source";
import { Synth } from "./Synth";
import { readOnly } from "../core/util/Interface";
import { omitFromObject, optionsFromArguments } from "../core/util/Defaults";
/**
 * Base class for both AM and FM synths
 */

export var ModulationSynth = /*#__PURE__*/function (_Monophonic) {
  _inherits(ModulationSynth, _Monophonic);

  var _super = _createSuper(ModulationSynth);

  function ModulationSynth() {
    var _this;

    _classCallCheck(this, ModulationSynth);

    _this = _super.call(this, optionsFromArguments(ModulationSynth.getDefaults(), arguments));
    _this.name = "ModulationSynth";
    var options = optionsFromArguments(ModulationSynth.getDefaults(), arguments);
    _this._carrier = new Synth({
      context: _this.context,
      oscillator: options.oscillator,
      envelope: options.envelope,
      onsilence: function onsilence() {
        return _this.onsilence(_assertThisInitialized(_this));
      },
      volume: -10
    });
    _this._modulator = new Synth({
      context: _this.context,
      oscillator: options.modulation,
      envelope: options.modulationEnvelope,
      volume: -10
    });
    _this.oscillator = _this._carrier.oscillator;
    _this.envelope = _this._carrier.envelope;
    _this.modulation = _this._modulator.oscillator;
    _this.modulationEnvelope = _this._modulator.envelope;
    _this.frequency = new Signal({
      context: _this.context,
      units: "frequency"
    });
    _this.detune = new Signal({
      context: _this.context,
      value: options.detune,
      units: "cents"
    });
    _this.harmonicity = new Multiply({
      context: _this.context,
      value: options.harmonicity,
      minValue: 0
    });
    _this._modulationNode = new Gain({
      context: _this.context,
      gain: 0
    });
    readOnly(_assertThisInitialized(_this), ["frequency", "harmonicity", "oscillator", "envelope", "modulation", "modulationEnvelope", "detune"]);
    return _this;
  }

  _createClass(ModulationSynth, [{
    key: "_triggerEnvelopeAttack",
    value:
    /**
     * Trigger the attack portion of the note
     */
    function _triggerEnvelopeAttack(time, velocity) {
      // @ts-ignore
      this._carrier._triggerEnvelopeAttack(time, velocity); // @ts-ignore


      this._modulator._triggerEnvelopeAttack(time, velocity);
    }
    /**
     * Trigger the release portion of the note
     */

  }, {
    key: "_triggerEnvelopeRelease",
    value: function _triggerEnvelopeRelease(time) {
      // @ts-ignore
      this._carrier._triggerEnvelopeRelease(time); // @ts-ignore


      this._modulator._triggerEnvelopeRelease(time);

      return this;
    }
  }, {
    key: "getLevelAtTime",
    value: function getLevelAtTime(time) {
      time = this.toSeconds(time);
      return this.envelope.getValueAtTime(time);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ModulationSynth.prototype), "dispose", this).call(this);

      this._carrier.dispose();

      this._modulator.dispose();

      this.frequency.dispose();
      this.detune.dispose();
      this.harmonicity.dispose();

      this._modulationNode.dispose();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Monophonic.getDefaults(), {
        harmonicity: 3,
        oscillator: Object.assign(omitFromObject(OmniOscillator.getDefaults(), [].concat(_toConsumableArray(Object.keys(Source.getDefaults())), ["frequency", "detune"])), {
          type: "sine"
        }),
        envelope: Object.assign(omitFromObject(Envelope.getDefaults(), Object.keys(ToneAudioNode.getDefaults())), {
          attack: 0.01,
          decay: 0.01,
          sustain: 1,
          release: 0.5
        }),
        modulation: Object.assign(omitFromObject(OmniOscillator.getDefaults(), [].concat(_toConsumableArray(Object.keys(Source.getDefaults())), ["frequency", "detune"])), {
          type: "square"
        }),
        modulationEnvelope: Object.assign(omitFromObject(Envelope.getDefaults(), Object.keys(ToneAudioNode.getDefaults())), {
          attack: 0.5,
          decay: 0.0,
          sustain: 1,
          release: 0.5
        })
      });
    }
  }]);

  return ModulationSynth;
}(Monophonic);